import React from 'react';
var AKTooltip = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.tooltip' */
  '@atlaskit/tooltip');
});
var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(AKTooltip, {
    content: text
  }, children);
};
export default Tooltip;
export var TooltipFn = function TooltipFn(_ref2) {
  var props = _ref2.props,
    children = _ref2.children,
    Components = _ref2.Components,
    render = _ref2.render,
    renderChildren = _ref2.renderChildren,
    dispatch = _ref2.dispatch;
  var _ref3 = props,
    text = _ref3.text;
  var renderedChildren = renderChildren({
    Components: Components,
    children: children,
    render: render,
    dispatch: dispatch
  });
  return /*#__PURE__*/React.createElement(Tooltip, {
    text: text
  }, Array.isArray(renderedChildren) ? renderedChildren[0] : renderedChildren);
};